export default "__VITE_ASSET__32e0bc03__"